// WebRezPro booking strategy.
//
// URL shape:
//   ${site.reserveUrl}&date_from=yyyyMMdd&date_to=yyyyMMdd

import { format } from "date-fns";
import { resolveCheckout } from "./_context.js";

export default {
  buildBookingUrl(ctx) {
    const { site, arrivalDate } = ctx;
    const checkout = resolveCheckout(ctx);
    return `${site.reserveUrl}&date_from=${format(arrivalDate, "yyyyMMdd")}&date_to=${format(checkout, "yyyyMMdd")}`;
  },

  buildPreviewUrl(site) {
    return site.reserveUrl;
  },

  describeBookingInputs() {
    return {
      inputs: {
        arrivalDate: {
          status: "required",
          notes: "Encoded as &date_from=yyyyMMdd.",
        },
        departureDate: {
          status: "required",
          notes: "Encoded as &date_to=yyyyMMdd.",
        },
        ref: {
          status: "ignored",
          notes: "site.reserveUrl already identifies the property.",
        },
        partySize: {
          status: "ignored",
          defaultValue: 1,
          notes: "Not encoded in the WebRezPro URL.",
        },
      },
    };
  },
};
